import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeContext } from 'styled-components/macro'

const SIZES = {
  small: 1.25,
  large: 2.45,
}

const StyledSVG = styled.svg`
  width: ${({ theme, sizeFactor }) => theme.sizeByFactor(sizeFactor)};
  height: ${({ theme, sizeFactor }) => theme.sizeByFactor(sizeFactor)};
`

export const EuStars = ({ size }) => {
  const theme = useContext(ThemeContext)
  const starColor = theme?.colors?.nlStarColor || '#FFCC00'

  const stars = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 30 - 90) * (Math.PI / 180)
    const cx = 15 + 10 * Math.cos(angle)
    const cy = 15 + 10 * Math.sin(angle)
    return <circle key={i} cx={cx} cy={cy} r="1.8" />
  })

  return (
    <StyledSVG
      sizeFactor={SIZES[size]}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={starColor}>{stars}</g>
    </StyledSVG>
  )
}

EuStars.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
}

EuStars.defaultProps = {
  size: 'small',
}
